module.exports = __webpack_public_path__ + "static/media/emma_build.85137507.gif";